import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../../const";
import _ from 'lodash';
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
import { getJournee } from '../../../fiche-enfant/les-tabs-ducks/Journee.ducks'
import { fetchKids } from "../../../Kids-list.ducks";

// Activite actions

export const POST_ACTIVITE_PENDING = "POST_ACTIVITE_PENDING";
export const POST_ACTIVITE_REJECTED = "POST_ACTIVITE_REJECTED";
export const POST_ACTIVITE_FULFILLED = "POST_ACTIVITE_FULFILLED";

export const GET_ACTIVITE_PENDING = "GET_ACTIVITE_PENDING";
export const GET_ACTIVITE_REJECTED = "GET_ACTIVITE_REJECTED";
export const GET_ACTIVITE_FULFILLED = "GET_ACTIVITE_FULFILLED";

export const PUT_ACTIVITE_PENDING = "PUT_ACTIVITE_PENDING";
export const PUT_ACTIVITE_REJECTED = "PUT_ACTIVITE_REJECTED";
export const PUT_ACTIVITE_FULFILLED = "PUT_ACTIVITE_FULFILLED";

export const DELETE_ACTIVITE_PENDING = "DELETE_ACTIVITE_PENDING";
export const DELETE_ACTIVITE_REJECTED = "DELETE_ACTIVITE_REJECTED";
export const DELETE_ACTIVITE_FULFILLED = "DELETE_ACTIVITE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_ACTIVITE_PENDING:
    case GET_ACTIVITE_PENDING:
    case PUT_ACTIVITE_PENDING:
    case DELETE_ACTIVITE_PENDING:
      return true;
    case POST_ACTIVITE_REJECTED:
    case POST_ACTIVITE_FULFILLED:
    case GET_ACTIVITE_REJECTED:
    case GET_ACTIVITE_FULFILLED:
    case PUT_ACTIVITE_REJECTED:
    case PUT_ACTIVITE_FULFILLED:
    case DELETE_ACTIVITE_REJECTED:
    case DELETE_ACTIVITE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ACTIVITE_PENDING:
    case POST_ACTIVITE_FULFILLED:
    case GET_ACTIVITE_PENDING:
    case GET_ACTIVITE_FULFILLED:
    case PUT_ACTIVITE_PENDING:
    case PUT_ACTIVITE_FULFILLED:
    case DELETE_ACTIVITE_PENDING:
    case DELETE_ACTIVITE_FULFILLED:
      return null;
    case POST_ACTIVITE_REJECTED:
    case GET_ACTIVITE_REJECTED:
    case PUT_ACTIVITE_REJECTED:
    case DELETE_ACTIVITE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ACTIVITE_FULFILLED:
    case GET_ACTIVITE_FULFILLED:
    case PUT_ACTIVITE_FULFILLED:
    case DELETE_ACTIVITE_FULFILLED:

      return _.isEmpty(payload.data) ? null : payload.data;

    case POST_ACTIVITE_PENDING:
    case GET_ACTIVITE_PENDING:
    case PUT_ACTIVITE_PENDING:
      return null;
    case POST_ACTIVITE_REJECTED:
    case GET_ACTIVITE_REJECTED:
    case PUT_ACTIVITE_REJECTED:
      return null;

    default:
      return state;
  }
};

// Activite reducer
export default combineReducers({ loading, error, data });

export const postActiviteMulti = (tok, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/activites`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_ACTIVITE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_ACTIVITE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}

export const postActiviteSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/activites`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_ACTIVITE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_ACTIVITE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const getActiviteEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/activites/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_ACTIVITE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_ACTIVITE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updateActiviteEvent = (tok, idEvent, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/activites/${idEvent}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_ACTIVITE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_ACTIVITE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const DeleteActiviteEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/activites/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_ACTIVITE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_ACTIVITE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}